import { useState, ReactNode } from "react";
import Auth, { AdoraInternalUser, getAdoraUser } from "@adora/shared/utils/auth";
import DataDogManager from "@adora/shared/utils/datadog";
import { useCookieSessionMonitor } from "@adora/shared/hooks/use-cookie-session-monitor";
import UserContext from "./user-context";

const UserProvider = ({ children }: { children: ReactNode }) => {
  const adoraUser = getAdoraUser() as AdoraInternalUser;
  const [user, setUser] = useState<AdoraInternalUser>(adoraUser);

  // Monitor cookie session and auto-logout when cookies expire
  useCookieSessionMonitor({
    authTokenKey: "adora-auth-token",
    onSessionExpired: () => {
      Auth.logout("preserve-redirect");
    },
    checkInterval: 10_000, // Check every 10 seconds
    enabled: !!user // Only monitor if user is logged in
  });

  if (user) {
    DataDogManager.updateUserInfo({ id: user.id, role: user.role });
  }

  const value = { user, setUser };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserProvider;
